import React from "react";
import { format } from "date-fns";
import { fullDateLongFormat } from "@common/helpers/date";
import { FiltersTypes } from "@common/types/filters/general";
import { WORK_DELIVERY_DATE_PRESET_LABELS } from "@components/pageHeader/filters/Tabs/WorkDeliveryDateFilter/workDeliveryDatePresets";

interface Props {
    filters: FiltersTypes;
}

export const WorkDeliveryDateFilterLabel: React.FC<Props> = ({ filters }) => {
    const {
        workDeliveryDateStart,
        workDeliveryDateEnd,
        workDeliveryDatePreset,
    } = filters;

    if (workDeliveryDatePreset) {
        return (
            <span>
                {WORK_DELIVERY_DATE_PRESET_LABELS[workDeliveryDatePreset]}
            </span>
        );
    }

    if (!workDeliveryDateStart && !workDeliveryDateEnd) {
        return null;
    }

    if (workDeliveryDateStart && workDeliveryDateEnd) {
        return (
            <span>
                {format(workDeliveryDateStart, fullDateLongFormat)} -{" "}
                {format(workDeliveryDateEnd, fullDateLongFormat)}
            </span>
        );
    }

    if (workDeliveryDateStart) {
        return (
            <span>
                From {format(workDeliveryDateStart, fullDateLongFormat)}
            </span>
        );
    }

    if (workDeliveryDateEnd) {
        return (
            <span>Until {format(workDeliveryDateEnd, fullDateLongFormat)}</span>
        );
    }

    return null;
};
